
<div class="py-1"></div>
<div *ngFor="let item of midMenu; let i = index" class="{{item.css}}" (click)="selectMidMenu(i, item.id)"
    [attr.dpad]="DpadZoneType.TV_USER_SETTINGS_MID" [style.--scale-dpad]="1" x-dpad="0" [attr.y-dpad]="i">
    {{item.name}}
</div>